module.exports = __webpack_public_path__ + "img/stock-photo-laughing-cheerful-funny-young-bearded-business-man-s@2x.e5e8d1ea.png";